(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-mega-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.mega-menu').forEach(menu => {
    const previewImg = menu.querySelector('.mega-menu__preview img');
    if (!previewImg) return;

    menu.querySelectorAll('a[data-preview]').forEach(link => {
      link.addEventListener('mouseenter', () => {
        const imgSrc = link.getAttribute('data-preview');
        if (imgSrc) {
          previewImg.src = imgSrc;
          previewImg.style.opacity = '1';
        }
      });
      link.addEventListener('mouseleave', () => {
        previewImg.style.opacity = '0';
      });
    });
  });
});
  } catch(e) { console.error(e); }
})();

})();
